import React, { useContext, useRef } from 'react';
import { CountingCirclesRecord } from 'api/api.types';
import ApiContext from 'api/ApiContext';
import { Loading } from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import MapTooltip from '../MapTooltip/MapTooltip';
import WorldMap from '../WorldMap';
import ProportionalMapKey from './ProportionalMapKey';

interface Props {
  map: string;
  hoveredElement: CountingCirclesRecord | null;
  selectedElement: CountingCirclesRecord | null;
  isLoading: boolean;
  records: CountingCirclesRecord[];
}

const ProportionalMap = ({
  map,
  hoveredElement,
  selectedElement,
  isLoading,
  records,
}: Props) => {
  const { t } = useTranslation('wap');

  const wrapperRef = useRef<HTMLDivElement>(null);
  const { language } = useContext(ApiContext);

  return (
    <div
      className={classNames('proportionalmap', {
        'proportionalmap--selected': selectedElement,
      })}
      ref={wrapperRef}
    >
      {isLoading && <Loading size="big" />}
      {!isLoading && !map && <p>{t('map_not_available')}</p>}
      <div className="proportionalmap__container">
        <div className="proportionalmap__maps">
          <div
            className="proportionalmap__map"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: map }}
          />
          <WorldMap isNational records={records} map={map} />
        </div>
        <ProportionalMapKey />
      </div>
      <MapTooltip
        wrapperRef={wrapperRef}
        bfsNumber={hoveredElement?.bfs_number}
        title={hoveredElement?.name?.[language]}
      />
    </div>
  );
};

export default ProportionalMap;
